import type { Infer } from 'superstruct';
import {
	boolean,
	integer,
	nullable,
	number,
	object,
	optional,
	string,
} from 'superstruct';

import { stringDate } from '@adflow/shared/util-superstruct';

import { MediaDestinationDto, MediaKindDto } from './media-types.dto';

export const ViewMediaDto = object({
	id: integer(),
	name: string(),
	kind: MediaKindDto,
	destination: MediaDestinationDto,
	url: string(),
	thumbnailUrl: optional(nullable(string())),
	size: nullable(integer()),
	width: nullable(integer()),
	height: nullable(integer()),
	aspectRatio: nullable(string()),
	duration: nullable(number()),
	createdAt: stringDate(),
	updatedAt: stringDate(),
	archived: boolean(),
	logo: boolean(),
	googleAdsAccount: optional(
		nullable(
			object({
				id: number(),
				avbId: string(),
				name: string(),
			})
		)
	),
});

export type ViewMediaDto = Infer<typeof ViewMediaDto>;
